import { render, staticRenderFns } from "./GroupDashboardAgentSummary.vue?vue&type=template&id=45bc4c2d&"
import script from "./GroupDashboardAgentSummary.vue?vue&type=script&lang=js&"
export * from "./GroupDashboardAgentSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports